import { FC } from "react";
import Choices from "../Choices";
import { aluminumRails, bifoldCladRails, cladRails, swingCladRails, windowRails, woodRails } from "./defaults";

function isChecked(label: string, stileCategory: string) {
  return label?.split(" ")[0] === stileCategory;
}

function getVariant(label: string, stileCategory: string) {
  return label?.split(" ")[0] === stileCategory ||
    label?.split(" ")[0] === stileCategory?.split(" ")[0]
    ? "filled"
    : "outlined";
}

interface PicoChipProps {
  label: string;
  stileCategory: string;
}

const PicoChip: FC<PicoChipProps> = ({ label, stileCategory }) => {
  return (
    <Choices
      label={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            alt="pico txt"
            src={`https://res.cloudinary.com/ag-millworks/image/upload/Pico_Text/svg/pico_${
              stileCategory === "Pico" ? "white" : "blue"
            }.svg`}
            style={{ width: 50, height: "auto" }}
          />
          <span style={{ paddingLeft: 5 }}> | Minimalist</span>
        </div>
      }
      variant={getVariant(label, stileCategory)}
      checkMark={isChecked(label, stileCategory)}
    />
  );
};

export function showStilesOptions(
  doorType: string,
  materialChoice: string,
  stileCategory: string,
  handleClick: (label: string, type: string) => void,
  chosenConfig: string,
  panelErr: { slimline?: string; euro?: string; euroTrad?: string },
  height: number
) {
   if (materialChoice === "aluminum") {
    return (
      <>
        {aluminumRails.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
          >
            <Choices
              label={state.label}
              variant={
                state.label?.split(" ")[0] === stileCategory ||
                state.label?.split(" ")[0] === stileCategory?.split(" ")[0]
                  ? "filled"
                  : "outlined"
              }
              checkMark={state.label?.split(" ")[0] === stileCategory}
            />
          </div>
        ))}
      </>
    );
  }
  
  if (doorType === "Bi-fold Window" && materialChoice) {
    const windowStilesRails =
      materialChoice === "wood" ||
      height < 38
        ? windowRails.filter((itm) => itm.stileCategory !== "Pico")
        : windowRails;

    return (
      <>
        {windowStilesRails.map((state) => (
          <div
            key={state.id}
            style={{ paddingLeft: 5, paddingRight: 5 }}
            onClick={() => handleClick(state.label, state.type)}
          >
            {state.label?.includes("Pico") ? (
              <PicoChip label={state.label} stileCategory={stileCategory} />
            ) : (
              <Choices
                label={state.label}
                variant={getVariant(state.label, stileCategory)}
                checkMark={isChecked(state.label, stileCategory)}
              />
            )}
          </div>
        ))}
      </>
    );
  }

  if (doorType === "Pivot" && materialChoice) {
    const rails = materialChoice === "wood" ? woodRails : cladRails;

    return (
      <>
        {rails
          .filter((item) =>
            panelErr.slimline && panelErr.euro
              ? item.label.includes("Traditional")
              : panelErr.slimline
              ? !item.label.includes("Slimline")
              : item
          )
          .map((state) => (
            <div
              key={state.id}
              onClick={() => handleClick(state.label, state.type)}
            >
              <Choices
                label={state.label}
                variant={getVariant(state.label, stileCategory)}
                checkMark={isChecked(state.label, stileCategory)}
              />
            </div>
          ))}
      </>
    );
  }

  if (
    materialChoice === "clad" &&
    (doorType?.includes("Bi-fold") ||
      chosenConfig === "Fixed Bi-fold" ||
      chosenConfig === "Fixed Full Bound")
  ) {
    return (
      <>
        {bifoldCladRails.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
            style={{ paddingLeft: 5, paddingRight: 5 }}
          >
            {state.label?.includes("Pico") ? (
              <PicoChip label={state.label} stileCategory={stileCategory} />
            ) : (
              <Choices
                label={state.label}
                variant={getVariant(state.label, stileCategory)}
                checkMark={isChecked(state.label, stileCategory)}
              />
            )}
          </div>
        ))}
      </>
    );
  }

  if (doorType === "Slider" && materialChoice) {
    const sliderStilesRails = materialChoice === "clad" ? cladRails : woodRails;
    return (
      <>
        {sliderStilesRails
          .filter((item) =>
            ["PX", "XP", "PX-AP", "PA-XP"].includes(chosenConfig)
              ? !item.label.includes("Slimline")
              : panelErr.slimline && !panelErr.euroTrad
              ? !item.label.includes("Slimline")
              : !panelErr.slimline && panelErr.euroTrad
              ? item.label.includes("Slimline")
              : panelErr.slimline && panelErr.euroTrad
              ? item.label === null
              : item
          )
          .map((state) => (
            <div
              key={state.id}
              onClick={() => handleClick(state.label, state.type)}
            >
              <Choices
                label={state.label}
                variant={getVariant(state.label, stileCategory)}
                checkMark={isChecked(state.label, stileCategory)}
              />
            </div>
          ))}
      </>
    );
  }

    if (doorType === "Swing" && materialChoice === "clad") {
    return (
      <>
        {swingCladRails.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
          >
            {state.label?.includes("Pico") ? (
              <PicoChip label={state.label} stileCategory={stileCategory} />
            ) : (
              <Choices
                label={state.label}
                variant={getVariant(state.label, stileCategory)}
                checkMark={isChecked(state.label, stileCategory)}
              />
            )}
          </div>
        ))}
      </>
    );
  }

  if (materialChoice === "clad") {
    return (
      <>
        {cladRails.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
          >
            <Choices
              label={state.label}
              variant={getVariant(state.label, stileCategory)}
              checkMark={isChecked(state.label, stileCategory)}
            />
          </div>
        ))}
      </>
    );
  }

  if (materialChoice === "wood") {
    return (
      <>
        {woodRails.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
          >
            <Choices
              label={state.label}
              variant={getVariant(state.label, stileCategory)}
              checkMark={isChecked(state.label, stileCategory)}
            />
          </div>
        ))}
      </>
    );
  }

  return null;
}
